import { routes as pagina } from './pagina'
export default [
  {
    path: '/global',
    name: 'Global',
    description: 'Módulo Global',
    children: [
      ...pagina,
    ],
    goesToMenu: true
  }
]
